
import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { IdentifiersDialog } from "@freyr/freyr-react-common-components";
// import useIdentifiersDialogsStore from "../../../../stores/useIdentifiersDialogsStore";
import { useShallow } from 'zustand/react/shallow';
// import { batchBindIdentifier, batchRemoveIdentifier, saveIdentifier } from "../../../../apis/apiFunctions";
import { EnqueueSnackbar } from "notistack";
import useIdentifiersDialogsStore from "../hooks/useIdentifierDialogsStore";
import { batchBindIdentifier, batchRemoveIdentifier, saveIdentifier } from "../api/identifierApi";
import SuccessIcon from "../assets/images/success-icon.svg";

interface IdentifiersDialogsProps {
  rowSelectionModel: GridRowSelectionModel;
  disableIdentifierList: string[];
  setRowSelectionModel: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>;
  queryResponseId: string;
  associatedId: string;
  parentIndetifierList?: any[];
  openSnackbar: EnqueueSnackbar
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  refresh?: (flag?: boolean) => void;
  slotprops?: any;
}


export const handleSelectedIdentifiers = (
  filterList: any,
  identifierList = [] as any[]
) => {
  let afterFilterList = {} as any;
  for (let key in filterList) {
    if (!identifierList.includes(key)) {
      if (Array.isArray(filterList[key])) {
        if (filterList[key].length > 0) {
          afterFilterList[key] = filterList[key];
        }
      } else {
        afterFilterList[key] = [filterList[key]];
      }
    }
  }
  return afterFilterList;
};


export const IdentifiersDialogs: React.FC<Partial<IdentifiersDialogsProps>> =
React.memo(function IdentifiersDialogs({
  rowSelectionModel,
  setRowSelectionModel,
  openSnackbar
}) {  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  const disableIdentifierList: string[] = [];

  const saveBatchBindIdentifier = (item: any) => {
    if (
      !item.identifierMap ||
      JSON.stringify(item.identifierMap) === "{}"
    )
      return;
    let body = {
      xevmpdIds: rowSelectionModel,
      identifierMap: handleSelectedIdentifiers(item.identifierMap, [])
    };
    // Implement once API is ready
    setLoading(true);
    if (item.batchAction === "add") {
      batchBindIdentifier(body as any)
        .then((data: any) => {
          onBatchIdentifierSuccess(data.data?.data);
          // refresh?.(true);
        })
        .catch((err: any) => {
          if (
            err?.response?.status === 401 ||
            err?.response?.data?.message === "unauthorized"
          ) {
            return;
          }
          openSnackbar?.(err.response.data.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        })
      .finally(() => {
        setLoading(false);
      });
    } else {
      batchRemoveIdentifier(body as any)
        .then((data: any) => {
          onBatchIdentifierSuccess(data.data?.data);
        })
        .catch((err: any) => {
          if (
            err?.response?.status === 401 ||
            err?.response?.data?.message === "unauthorized"
          ) {
            return;
          }
          openSnackbar?.(err.response.data.message, {
            variant: "error",
            anchorOrigin: { vertical: "top", horizontal: "center" },
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const saveSingleBindIdentifier = async (item: any) => {
    const body = {
      registrationId: associatedApplicationId,
      identifierMap: handleSelectedIdentifiers(item.identifierMap),
    };
    saveIdentifier(body)
    .then(value => {
      if(value?.data?.data) {
        openSnackbar?.(t("identifiers.saveSuccess"), { variant: "success", anchorOrigin: { vertical: 'top', horizontal: 'center' } });   
      } else {
        openSnackbar?.(t("identifiers.saveError"), { variant: "error", anchorOrigin: { vertical: 'top', horizontal: 'center' } });      
      }
  
      // refresh?.(true); //implement this method, once backend is done
    })
    .catch(() => {
      openSnackbar?.(t("identifiers.saveError"), { variant: "error", anchorOrigin: { vertical: 'top', horizontal: 'center' } });      
    });
  };

  const {
    closeManageIdentifierPop, closeSingleIdentifierPop, updateOpenBulkIdentifierDialog, onBatchIdentifierSuccess,
    showManageIdentifierPop, showSingleManageIdentifierPop, openBulkIdentifierDialog,
    initFilterList, successCount, associatedApplicationId
  } = useIdentifiersDialogsStore(useShallow(state => ({
    closeManageIdentifierPop: state.closeManageIdentifierPop,
    closeSingleIdentifierPop: state.closeSingleIdentifierPop,
    updateOpenBulkIdentifierDialog: state.updateOpenBulkIdentifierDialog,
    onBatchIdentifierSuccess: state.onBatchIdentifierSuccess,
    onSingleIdentifierSuccess: state.onSingleIdentifierSuccess,
    openManageIdentifierPop: state.openManageIdentifierPop,
    showSingleManageIdentifierPop: state.showSingleManageIdentifierPop,
    showManageIdentifierPop: state.showManageIdentifierPop,
    openBulkIdentifierDialog: state.openBulkIdentifierDialog,
    initFilterList: state.initFilterList,
    successCount: state.successCount,
    associatedApplicationId: state.associatedXevmpdId,
  })));

  return (
    <div>
   
      <IdentifiersDialog
        open={showManageIdentifierPop || showSingleManageIdentifierPop}
        //setLoading={setLoading}
        isBatchMode={showManageIdentifierPop}
        title={t("identifiers.title")}
        defaultIdentifiersKey={disableIdentifierList}
        initialIdentifierMap={initFilterList || {}}
        selectedRecordsCount={rowSelectionModel?.length}
        onClose={() => {
          document.body.classList.remove('identifiers-dialog-open');
          if (showSingleManageIdentifierPop) {
            closeSingleIdentifierPop();
          } else {
            closeManageIdentifierPop();
          }
        }}
        onSave={(item: any) => {
          if (showSingleManageIdentifierPop) {
            saveSingleBindIdentifier(item);
          } else {
            saveBatchBindIdentifier(item);
          }
        }}
      />

      <Dialog
        open={openBulkIdentifierDialog}
        maxWidth="xs"
        fullWidth
        className="popup-dialog"
        slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(15, 15, 15, 0.4) !important",
          },
        },
      }}
      >
        <Box component="form" sx={{ display: "flex", flexDirection: "column" }}>
          <DialogContent className="form-group popup-content">
            <Grid container>
              <Grid item xs={12} sx={{ position: "relative" }}>
                <img
                  alt=""
                  className="common-dialog-delete-img"
                  src={SuccessIcon}
                ></img>
                <Typography variant="h5" sx={{ textAlign: "center" }} gutterBottom>
                  {t?.("identifiers.updateSuccessTip") ?? "Identifiers updated successfully!"}
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ my: 2 }}
                  className="alert-notify-text text-center"
                >
                  {(t?.("identifiers.updateSuccessTipWithNumber", {
                    successCount: successCount,
                    allCount: rowSelectionModel?.length,
                  })) ??
                    `${successCount} out of ${rowSelectionModel?.length} record(s) updated successfully!`}
                </Typography>
              </Grid>

              <Grid item xs={12} textAlign={"center"} sx={{ my: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    updateOpenBulkIdentifierDialog(false);
                    setRowSelectionModel?.([]);
                  }}
                >
                  {t?.("common.yes") ?? "Yes"}
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Box>
      </Dialog>
    </div>
  );
});

// export const openIdentifiersDialog = (options?: {
//   mode?: "batch" | "single";
//   initialIdentifierMap?: Record<string, string[]>;
// }) => {
  // const { mode = "batch", initialIdentifierMap = {} } = options || {};
  // if (mode === "batch") {
  //   // openManageIdentifierPop(initialIdentifierMap);
  // } else {
  //   // openSingleManageIdentifierPop(initialIdentifierMap);
  // }
// };


